module.exports = __webpack_public_path__ + "img/role-nothing.653bfe2b.png";